import React, { useEffect, useState } from "react";
import { Col, Row, Tabs, Tab } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import {
  setCurrentPageTitle,
  setCurrentRoute,
} from "../app/store/layoutUI";

// Components
import AgencyInvoiceBased from "../app/components/Reports/Monthly/Financial/AgencyInvoiceBased";
import AgencyCandidateBased from "../app/components/Reports/Monthly/Financial/AgencyCandidateBased";
import SubcontractorCandidates from "../app/components/Reports/Monthly/Payment/SubcontractorCandidates";
import RecruiterCandidates from "../app/components/Reports/Monthly/Payment/RecruiterCandidates";
import AgencyInvoiceCandidate from "../app/components/Reports/Monthly/AgencyInvoiceCandidate";
import GrossProfitCandidates from "../app/components/Reports/Monthly/GrossProfitCandidates";
import BurnHourCandidate from "../app/components/Reports/Monthly/BurnHourCandidate";
import AgencyInvBased from "../app/components/Reports/Quarterly/Financial/AgencyInvBased";
import AgencyCanBased from "../app/components/Reports/Quarterly/Financial/AgencyCanBased";
import AgencyInvoicePayment from "../app/components/Reports/Other/AgencyInvoicePayment";
import SubcontractorComp from "../app/components/Reports/Compliance/SubcontractorComp";
import RecruiterComp from "../app/components/Reports/Compliance/RecruiterComp";
import W2CandidateComp from "../app/components/Reports/Compliance/W2CandidateComp";
import Ten99CandidateComp from "../app/components/Reports/Compliance/Ten99CandidateComp";
import BurnHrCandidate from "../app/components/Reports/Quarterly/BurnHrCandidate";
import AchInformation from "../app/components/Reports/Other/AchInformation";
import InsuranceInformation from "../app/components/Reports/Other/InsuranceInformation";
import CandidateVisaStatus from "../app/components/Reports/Other/CandidateVisaStatus";
import SubcontractorRecruiter from "../app/components/Reports/Monthly/Ach/SubcontractorRecruiter";

const CustomReport = () => {
  const dispatch = useDispatch();
  const { type } = useParams();

  const [selectedReport, setSelectedReport] = useState("Select Report");
  const [selectedCompliance, setSelectedCompliance] = useState("Select the Entity to send the reports to");
  const [activeKey, setActiveKey] = useState("internal");
  const [searchTerm, setSearchTerm] = useState("");

  // ------------------------------
  // Report / Compliance definitions with UI metadata (Black & White Theme)
  // ------------------------------
  const reportOptions = [
    {
      name: "ACH Information Reports",
      description: "Overview of ACH banking details for active performers and vendor partners.",
      icon: "fa-university",
      color: "rgba(23, 23, 23, 0.06)",
      iconColor: "#171717",
      component: <AchInformation />
    },
    {
      name: "Insurance Information Reports",
      description: "Summary of general liability insurance coverage and active policies.",
      icon: "fa-shield",
      color: "rgba(23, 23, 23, 0.06)",
      iconColor: "#171717",
      component: <InsuranceInformation />
    },
    {
      name: "Candidate Visa Status Reports",
      description: "Track candidate work eligibility, visa types, and expiration statuses.",
      icon: "fa-id-card-o",
      color: "rgba(23, 23, 23, 0.06)",
      iconColor: "#171717",
      component: <CandidateVisaStatus />
    },
    {
      name: "Monthly ACH - Payments",
      description: "Review automated clearing house (ACH) payouts for subcontractors and recruiters.",
      icon: "fa-money",
      color: "rgba(23, 23, 23, 0.06)",
      iconColor: "#171717",
      component: <SubcontractorRecruiter />
    },
    {
      name: "Financial Report - (Accrual Basis - Invoice Based)",
      description: "Accrual basis billing insights based on generated client invoices.",
      icon: "fa-line-chart",
      color: "rgba(23, 23, 23, 0.06)",
      iconColor: "#171717",
      component: <AgencyInvoiceBased />
    },
    {
      name: "Financial Report - (Accrual Basis - Candidate Based)",
      description: "Accrual basis reports categorized by candidate earnings.",
      icon: "fa-bar-chart",
      color: "rgba(23, 23, 23, 0.06)",
      iconColor: "#171717",
      component: <AgencyCandidateBased />
    },
    {
      name: "Monthly Payments (Per Candidate Basis)",
      description: "Monthly payout structures organized by individual candidates.",
      icon: "fa-calculator",
      color: "rgba(23, 23, 23, 0.06)",
      iconColor: "#171717",
      component: <SubcontractorCandidates />
    },
    {
      name: "Monthly Invoices to Client (Per Candidate-Basis)",
      description: "Client billing tracking grouped per candidate engagement.",
      icon: "fa-file-text-o",
      color: "rgba(23, 23, 23, 0.06)",
      iconColor: "#171717",
      component: <AgencyInvoiceCandidate />
    },
    {
      name: "Monthly Gross Profit Reports - Per Candidate Basis",
      description: "Check net profit yield and margins generated per candidate placement.",
      icon: "fa-pie-chart",
      color: "rgba(23, 23, 23, 0.06)",
      iconColor: "#171717",
      component: <GrossProfitCandidates />
    },
    {
      name: "Burn Reports - Per Candidate Basis",
      description: "Hourly burn rates, project limits, and candidate engagement lifetimes.",
      icon: "fa-fire",
      color: "rgba(23, 23, 23, 0.06)",
      iconColor: "#171717",
      component: <BurnHourCandidate />
    }
  ];

  const complianceOptions = [
    {
      name: "Subcontractors",
      description: "Enrollment tracking, state certifications, and subcontractor validation docs.",
      icon: "fa-handshake-o",
      color: "rgba(23, 23, 23, 0.06)",
      iconColor: "#171717",
      component: <SubcontractorComp />
    },
    {
      name: "Recruiters",
      description: "Recruiter registration forms, identity validations, and compliance checklists.",
      icon: "fa-users",
      color: "rgba(23, 23, 23, 0.06)",
      iconColor: "#171717",
      component: <RecruiterComp />
    },
    {
      name: "W2 Candidates",
      description: "Employment tax documents, payroll registrations, and W2 identity forms.",
      icon: "fa-file-text",
      color: "rgba(23, 23, 23, 0.06)",
      iconColor: "#171717",
      component: <W2CandidateComp />
    },
    {
      name: "1099 Candidates",
      description: "Independent contractor declarations, classifications, and tax logs.",
      icon: "fa-briefcase",
      color: "rgba(23, 23, 23, 0.06)",
      iconColor: "#171717",
      component: <Ten99CandidateComp />
    }
  ];

  useEffect(() => {
    const pageTitle = type === "compliance" ? "Compliance Reports" : "Business Reports";
    dispatch(setCurrentPageTitle(pageTitle));
    dispatch(setCurrentRoute([{ name: "Analytics", url: "" }]));

    // Reset selections on path change
    setSelectedReport("Select Report");
    setSelectedCompliance("Select the Entity to send the reports to");
    setSearchTerm("");
  }, [type, dispatch]);

  const handleTabSelect = (k) => {
    setActiveKey(k);
    setSelectedReport("Select Report");
    setSearchTerm("");
  };

  const handleRefresh = () => {
    setSelectedReport("Select Report");
    setSelectedCompliance("Select the Entity to send the reports to");
    setSearchTerm("");
  };

  // ------------------------------
  // Catalog Rendering logic
  // ------------------------------
  const renderCatalogGrid = (options, selectedValue, onSelect, placeholderText) => {
    const filtered = options.filter(
      (opt) =>
        opt.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        opt.description.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
      <React.Fragment>
        <div className="cr-search-wrapper">
          <i className="fa fa-search cr-search-icon"></i>
          <input
            type="text"
            placeholder={placeholderText}
            className="cr-search-input"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        {filtered.length > 0 ? (
          <div className="cr-grid">
            {filtered.map((opt) => (
              <div className="cr-card" key={opt.name} onClick={() => onSelect(opt.name)}>
                <div className="cr-card-top-row">
                  <div className="cr-icon-wrapper">
                    <i className={`fa ${opt.icon}`}></i>
                  </div>
                  <div className="cr-card-footer">
                    <span>Run Report</span>
                    <i className="fa fa-chevron-right"></i>
                  </div>
                </div>
                <h4 className="cr-card-title">{opt.name}</h4>
                <p className="cr-card-desc">{opt.description}</p>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-5 bg-white border rounded-0" style={{ borderRadius: "0", fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' }}>
            <i className="fa fa-folder-open-o fa-2x mb-2 d-block" style={{ color: "#94a3b8" }}></i>
            <p style={{ margin: 0, fontSize: "14px", fontWeight: 400, color: "#64748b" }}>No reports matched your filter criteria</p>
          </div>
        )}
      </React.Fragment>
    );
  };

  const renderActiveReportView = (options, selectedValue, onBack, breadcrumbCategory) => {
    const match = options.find((item) => item.name === selectedValue);
    if (!match) return null;

    return (
      <React.Fragment>
        <div className="cr-header">
          <div className="cr-breadcrumb">
            <span>{breadcrumbCategory}</span>
            <i className="fa fa-angle-right text-muted"></i>
            <span className="active-node">{selectedValue}</span>
          </div>
          <button className="cr-btn-back" onClick={onBack}>
            <i className="fa fa-arrow-left"></i> Back
          </button>
        </div>
        <div className="animate-fade-in pt-1">
          {match.component}
        </div>
      </React.Fragment>
    );
  };

  return (
    <React.Fragment>
      <style>{`
        /* Black & White Theme Styling for CustomReport Hub (matching WorkflowUser) */
        .cr-hub {
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
          background: #f8fafc;
          min-height: calc(100vh - 120px);
          padding: 8px 0;
        }

        .cr-title {
          font-size: 18px;
          font-weight: 500;
          color: #1e293b;
          letter-spacing: -0.02em;
        }

        .cr-subtitle {
          font-size: 14px;
          font-weight: 400;
          color: #64748b;
        }

        /* Search input bar styling */
        .cr-search-wrapper {
          position: relative;
          max-width: 400px;
          margin-bottom: 24px;
        }

        .cr-search-input {
          width: 100%;
          padding: 9px 16px 9px 38px;
          background: #ffffff;
          border: 1px solid #cbd5e1;
          border-radius: 0;
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
          font-size: 14px;
          font-weight: 400;
          color: #1e293b;
          transition: all 0.2s ease;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08);
        }

        .cr-search-input:focus {
          outline: none;
          border-color: #171717;
          box-shadow: 0 0 0 4px rgba(23, 23, 23, 0.1);
          background: #fafafa;
        }

        .cr-search-icon {
          position: absolute;
          left: 14px;
          top: 50%;
          transform: translateY(-50%);
          color: #94a3b8;
          font-size: 14px;
        }

        /* Enhanced Catalog Grid Layout */
        .cr-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(290px, 1fr));
          gap: 20px;
          margin-bottom: 30px;
        }

        .cr-card {
          background: #ffffff;
          border: 1px solid rgba(226, 232, 240, 0.9);
          border-radius: 0 !important;
          padding: 20px 22px;
          display: flex;
          flex-direction: column;
          box-shadow: 0 4px 20px -4px rgba(15, 23, 42, 0.05);
          transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
          cursor: pointer;
          height: 100%;
          position: relative;
        }

        .cr-card:hover {
          transform: translateY(-3px);
          border-color: #cbd5e1;
          box-shadow: 0 14px 28px -4px rgba(15, 23, 42, 0.09), 0 2px 6px -1px rgba(15, 23, 42, 0.04);
        }

        .cr-card-top-row {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 16px;
          gap: 12px;
        }

        .cr-icon-wrapper {
          width: 38px;
          height: 38px;
          border-radius: 0 !important;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 16px;
          margin-bottom: 0 !important;
          transition: all 0.25s ease;
          background: #f1f5f9 !important;
          color: #171717 !important;
          border: 1px solid #e2e8f0 !important;
          flex-shrink: 0;
        }

        .cr-card:hover .cr-icon-wrapper {
          transform: scale(1.05);
          background: #e2e8f0 !important;
          border-color: #cbd5e1 !important;
        }

        .cr-card-title {
          font-size: 14px;
          font-weight: 500;
          color: #1e293b;
          letter-spacing: -0.01em;
          margin-bottom: 6px;
          line-height: 1.35;
        }

        .cr-card-desc {
          font-size: 14px;
          font-weight: 400;
          color: #64748b;
          line-height: 1.55;
          margin-bottom: 0;
          flex-grow: 1;
        }

        .cr-card-footer {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 7px;
          height: auto;
          min-height: 32px;
          padding: 7px 14px;
          border-radius: 0;
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
          font-size: 14px;
          font-weight: 500;
          color: #1e293b;
          background: #ffffff;
          border: 1px solid #cbd5e1;
          transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
          white-space: nowrap;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08);
        }

        .cr-card-footer i {
          font-size: 14px;
          transition: transform 0.25s ease, color 0.25s ease;
        }

        .cr-card:hover .cr-card-footer {
          background: #f8fafc;
          color: #0f172a;
          border-color: #94a3b8;
          box-shadow: 0 2px 6px rgba(15, 23, 42, 0.08);
        }

        .cr-card:hover .cr-card-footer i {
          transform: translateX(3px);
        }

        /* Active view header styles */
        .cr-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          background: transparent;
          border-bottom: 1px solid #e5e7eb;
          padding: 0 0 12px 0;
          margin-bottom: 16px;
        }

        .cr-breadcrumb {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 14px;
          font-weight: 500;
          color: #64748b;
        }

        .cr-breadcrumb .active-node {
          color: #1e293b;
          font-weight: 500;
        }

        .cr-btn-back {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 7px 14px;
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
          font-size: 14px;
          font-weight: 500;
          border-radius: 0;
          border: 1px solid #cbd5e1;
          background: #ffffff;
          color: #1e293b;
          cursor: pointer;
          transition: all 0.15s ease;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08);
        }

        .cr-btn-back:hover {
          background: #f8fafc;
          color: #0f172a;
          border-color: #94a3b8;
        }

        /* Premium Tabs (Matching WorkflowUser 100%) */
        .wf-tab-bar {
          display: flex;
          align-items: stretch;
          gap: 4px;
          border-bottom: 2px solid #e5e5e5;
          margin-bottom: 20px;
          padding: 8px 0 0;
          position: relative;
          flex: 0 0 auto;
        }

        .wf-tab-btn {
          position: relative;
          display: inline-flex;
          align-items: center;
          gap: 7px;
          border: none;
          background: transparent;
          padding: 9px 16px 11px;
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
          font-size: 14px;
          font-weight: 500;
          color: #1e293b;
          cursor: pointer;
          border-radius: 0;
          transition: color 0.2s ease, background 0.2s ease;
          outline: none;
          white-space: nowrap;
        }

        .wf-tab-btn i {
          font-size: 14px;
          color: currentColor;
          transition: color 0.2s ease;
        }

        .wf-tab-btn:hover {
          color: #171717;
          background: #f5f5f5;
        }

        .wf-tab-btn:focus,
        .wf-tab-btn:focus-visible,
        .wf-tab-btn:active {
          outline: none !important;
          box-shadow: none !important;
          border-color: transparent !important;
        }

        .wf-tab-btn.active {
          color: #ffffff;
          font-weight: 500;
          background: #171717;
        }

        .wf-tab-btn.active i {
          color: #ffffff;
        }

        .wf-tab-btn::after {
          content: "";
          position: absolute;
          bottom: -2px;
          left: 0;
          right: 0;
          height: 2px;
          background: #171717;
          border-radius: 0;
          transform: scaleX(0);
          transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
        }

        @keyframes tabFadeIn {
          from { opacity: 0; transform: translateY(6px); }
          to   { opacity: 1; transform: translateY(0); }
        }

        .wf-tab-panel {
          animation: tabFadeIn 0.28s cubic-bezier(0.16, 1, 0.3, 1) both;
          flex: 1 1 auto;
          min-height: auto;
          overflow-y: visible;
          overflow-x: hidden;
          padding-right: 4px;
        }

        /* WorkflowUser Card Layout & Header Bar */
        .wf-main-card {
          background: rgba(255, 255, 255, 0.97) !important;
          border: 1px solid rgba(226, 232, 240, 0.8) !important;
          box-shadow: 0 4px 24px -4px rgba(15, 23, 42, 0.06), 0 1px 4px -1px rgba(15, 23, 42, 0.04) !important;
          border-radius: 0 !important;
          transition: all 0.3s ease !important;
          overflow: hidden !important;
          position: relative !important;
          height: auto !important;
          min-height: 420px !important;
          display: flex !important;
          flex-direction: column !important;
          margin-bottom: 24px !important;
        }

        .wf-card-header-bar {
          position: relative !important;
          overflow: hidden !important;
          display: flex !important;
          align-items: center !important;
          justify-content: space-between !important;
          flex-wrap: wrap !important;
          gap: 12px !important;
          padding: 16px 22px !important;
          background: linear-gradient(90deg, #fafbfd 0%, #ffffff 100%) !important;
          border-bottom: 1px solid #f1f5f9 !important;
          border-radius: 0 !important;
          flex: 0 0 auto !important;
        }

        .wf-header-left {
          display: flex;
          align-items: center;
          gap: 14px;
          flex-wrap: wrap;
        }

        .btn-search-trigger {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 8px !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          padding: 7px 14px !important;
          border-radius: 0 !important;
          font-family: "Open Sans", sans-serif !important;
          font-size: 14px !important;
          font-weight: 500 !important;
          color: #1e293b !important;
          cursor: pointer !important;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08) !important;
          min-height: 32px !important;
          height: auto !important;
        }

        .btn-search-trigger:hover {
          background: #f8fafc !important;
          color: #0f172a !important;
          border-color: #cbd5e1 !important;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05) !important;
        }
      `}</style>

      <div className="cr-hub">
        <div className="card mb-4 shadow-none wf-main-card">
          {/* Card Header Bar matching WorkflowUser */}
          <div className="wf-card-header-bar">
            <div className="wf-header-left">
              <div>
                <h2 style={{ fontSize: "18px", fontWeight: 500, fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif', color: "#1e293b", margin: 0, lineHeight: 1.2 }}>
                  {type === "compliance" ? "Compliance Audit Center" : "Business Intelligence Hub"}
                </h2>
                <div style={{ fontSize: "14px", color: "#64748b", fontWeight: 400, fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif', marginTop: "3px" }}>
                  {type === "compliance"
                    ? "Assess recruitment, subcontractor, and candidate onboarding compliance forms and logs."
                    : "Review accrual reports, invoices, ACH payments, profit distributions, and workforce burns."}
                </div>
              </div>
            </div>
            <div>
              <button
                className="btn-search-trigger"
                onClick={handleRefresh}
                title="Refresh directory"
              >
                <i className="fa fa-refresh" aria-hidden="true" /> Refresh
              </button>
            </div>
          </div>

          {/* Card Body Content */}
          <div className="card-body px-3 pt-3 pb-3 wf-tabs-container">
            {type === "compliance" ? (
              /* ✅ COMPLIANCE HUB */
              <div className="cr-tabs">
                {selectedCompliance === "Select the Entity to send the reports to" ? (
                  /* Catalog Grid Mode */
                  renderCatalogGrid(
                    complianceOptions,
                    selectedCompliance,
                    setSelectedCompliance,
                    "Search compliance logs (Subcontractors, W2, Recruiters)..."
                  )
                ) : (
                  /* Active Report Mode */
                  renderActiveReportView(
                    complianceOptions,
                    selectedCompliance,
                    () => setSelectedCompliance("Select the Entity to send the reports to"),
                    "Compliance Audits"
                  )
                )}
              </div>
            ) : (
              /* ✅ BUSINESS HUB */
              <div className="cr-tabs">
                {/* Custom Tab Bar matching WorkflowUser */}
                <div className="wf-tab-bar">
                  <button
                    type="button"
                    className={`wf-tab-btn ${activeKey === "internal" ? "active" : ""}`}
                    onClick={() => handleTabSelect("internal")}
                  >
                    <i className="fa fa-file-text-o" />
                    Internal Reports
                  </button>
                  <button
                    type="button"
                    className={`wf-tab-btn ${activeKey === "agencies" ? "active" : ""}`}
                    onClick={() => handleTabSelect("agencies")}
                  >
                    <i className="fa fa-university" />
                    Agencies Ledger (Monthly/Quarterly/Yearly)
                  </button>
                </div>

                <div className="wf-tab-panel">
                  {activeKey === "internal" ? (
                    <div>
                      {selectedReport === "Select Report" ? (
                        /* Catalog Grid Mode */
                        renderCatalogGrid(
                          reportOptions,
                          selectedReport,
                          setSelectedReport,
                          "Search business reports (ACH, Visa, Gross Profit, Burn)..."
                        )
                      ) : (
                        /* Active Report Mode */
                        renderActiveReportView(
                          reportOptions,
                          selectedReport,
                          () => setSelectedReport("Select Report"),
                          "Internal Business"
                        )
                      )}
                    </div>
                  ) : (
                    <div className="animate-fade-in">
                      <AgencyInvoicePayment />
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CustomReport;
